import { useCallback } from "react";

/**
 * Plausible + GA4 analytics hook.
 * Plausible auto-tracks pageviews; GA4 auto-tracks via gtag config.
 * Custom events fire only in production (not localhost).
 */

const isProduction = () =>
  typeof window !== "undefined" &&
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1";

function sendGA4(eventName, params) {
  if (isProduction() && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}

export function useAnalytics() {
  const trackEvent = useCallback((eventName, props) => {
    if (typeof window.plausible === "function") {
      window.plausible(eventName, props ? { props } : undefined);
    }
  }, []);

  const trackGA4 = useCallback((eventName, params) => {
    sendGA4(eventName, params);
  }, []);

  return { trackEvent, trackGA4 };
}

export { sendGA4 };

// Event name constants
export const EVENTS = {
  START_FREE_GUIDE: "Start Free Guide",
  CHECK_ELIGIBILITY: "Check Eligibility",
  GENERATE_CHECKLIST: "Generate Checklist",
  TIMELINE_CALCULATOR: "Timeline Calculator",
  PRICING_VISIT: "Pricing Visit",
  UPGRADE_PREMIUM: "Upgrade to Premium",
};

// GA4 event name constants
export const GA4 = {
  CLICK_START_FREE: "click_start_free",
  CLICK_START_PREMIUM: "click_start_premium",
  CHECKOUT_STARTED: "checkout_started",
  CHECKOUT_SUCCESS: "checkout_success",
  MANAGE_SUBSCRIPTION_CLICKED: "manage_subscription_clicked",
  GUIDE_COMPLETED: "guide_completed",
  FORM_COMPLETE: "form_complete",
};
